<template>
    <a-modal title="新建日期标注" :maskClosable="false" @cancel="reset" v-model="isShow" wrapClassName="manage_modal mark_manage_model">
        <a-alert message="目前不支持标注拖动，因此尽量不要设置日期重叠的标注" banner />
        <a-form :form="form" ref="form">
            <!-- <a-form-item label="日期" :label-col="{span: 5}" :wrapper-col="{span: 12}">
                <a-range-picker v-decorator="['date', {rules: [{ required: true, message: '日期必填'}]}]"/>
            </a-form-item> -->
            <a-form-item label="日期时间" :label-col="{span: 5}" :wrapper-col="{span: 12}">
                <a-range-picker  format="YYYY-MM-DD HH:mm" :placeholder="['开始时间', '结束时间']" 
                    :showTime="{ minuteStep: 5, format: 'HH:mm', defaultValue: [moment('00:00', 'HH:mm'), moment('00:00', 'HH:mm')]}"
                    v-decorator="['date', {rules: [{ required: true, message: '日期必填'}]}]" />
            </a-form-item>
            <a-form-item label="标注" :label-col="{span: 5}" :wrapper-col="{span: 12}">
                <a-input style="width:300px" placeholder="二十个字以内" v-decorator="['text', {rules: [{ required: true, message: '标注必填',}, {max:20, message: '二十个字以内',}]}]"/>
            </a-form-item>
            <a-form-item label="补充说明" :label-col="{span: 5}" :wrapper-col="{span: 12}">
                <a-textarea :rows="4" style="width:300px;" placeholder="补充说明显示在标注Tip中" v-decorator="['tooltip', {rules: [{max:200, message: '200字以内',}]}]"/>
            </a-form-item>
            <a-form-item label=" " :label-col="{span: 5}" :wrapper-col="{span: 12}" class="is_all_item">
                <a-checkbox v-decorator="['is_all',{}]">应用于本项目所有页面</a-checkbox>
            </a-form-item>
        </a-form>
        <template slot="footer">
            <a-button key="submit" type="primary" @click="submit">应用</a-button>
            <a-button key="cancel" @click="reset">取消</a-button>
        </template>
    </a-modal>
</template>

<script>
import Vue from 'vue'
import { Checkbox } from 'ant-design-vue';
import moment from 'moment'
Vue.use(Checkbox)

export default {
    props: ['show', 'id'],
    model: {
        prop: 'show',
        event: 'close'
    },
    watch: {
        show() {
            this.isShow=this.show
        }
    },
    data() {
        return {
            moment,
            isShow: false,
            form: this.$form.createForm(this),
        }
    },
    methods: {
        submit() {
            this.form.validateFields((err, values) => {
                if (!err) {
                    let params = {
                        start_dt: values['date'][0].format('YYYY-MM-DD HH:mm:ss'),
                        end_dt: values['date'][1].format('YYYY-MM-DD HH:mm:ss'),
                        sub_module:this.id,
                        text: values['text'],
                        tooltip:values['tooltip'],
                        is_all:values['is_all']===true?true:false,
                    }
                    this.$service.addData(this.$service.api.manage.mark, params).then((data)=>{
                        this.$message.success('新增成功')
                        this.$store.commit('add_mark', data)
                        this.$emit("reload")
                        this.reset()
                    })
                }
            });
        },
        reset() {
            this.form.resetFields()
            this.$emit("close", false)
        }
  },
}
</script>
<style lang="less">
.mark_manage_model {
    .ant-form-item-control {
        width:300px;
    }
    .is_all_item {
        .ant-form-item-label label:after {
            content: ' '
        }
    }
}
</style>